import { api } from '../../utils/api'

export enum Errors {
	USER_NOT_FOUND = `USER_NOT_FOUND`
}

export const DoLogin = async (email: string, password: string) => await api.post(`/login`, { email, password })